module.exports = __webpack_public_path__ + "img/1.ec7f12f8.jpg";